import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { TaxonomyListView } from 'src/app/general/taxonomies/list/taxonomy-list.view';
import { TaxonomyListDataService } from 'src/app/general/taxonomies/list/taxonomy-list.data';

interface Props extends ControllerProps<{}> {
}

@observer
export class TaxonomyListController extends React.Component<Props, {}> {
	@resolve
	private dialogService: DialogService;

	@resolve
	private toast: ToastNotifications;

	@observable
	dataService: TaxonomyListDataService;

	constructor(props: Readonly<Props>) {
		super(props);
	}

	componentDidMount() {
		this.props.setBusy(true);

		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	private async loadData(): Promise<void> {
		this.dataService = TaxonomyListDataService.make();

		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);

		await this.dataService.load(query => query);
	}

	handleItemDoubleClick = (item: TaxonomySummary): void => {
		this.props.history.push(`/general/taxonomies/${item == null ? 'new' : item.id}`);
	};

	render() {
		if (this.dataService == null) {
			return null;
		}

		return (
			<TaxonomyListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClick={this.handleItemDoubleClick}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/list/taxonomy-list.controller.tsx